<h2 class="title">{{ title }}</h2>

<mat-card appearance="outlined">
  <span [innerHTML]="article.contenu"></span>
</mat-card>
